import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0a0a0a',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
    text: {
      primary: '#0a0a0a',
      secondary: '#666666',
    },
      surface: {
          callout: '#0000',
          calloutAnswer: '#f0f0f0',
          calloutSide: '#000',
          qaQuestion: '#f0f0f0',
          tableHeader: '#0a0a0a',
          tableRowAlt: '#f0f0f0',
          tableRow: '#e0e0e0',
      },
      others: {
          barsBg: '#d0d0d0',
          barsAc: '#0a0a0a'
      },
    divider: '#cccccc',
  },

  typography: {
    fontFamily: '"IBM Plex Sans", sans-serif',
    fontSize: 15,

    h1: {
      fontFamily: '"IBM Plex Serif", serif',
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: '"IBM Plex Serif", serif',
      fontSize: '1.375rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontFamily: '"IBM Plex Sans", sans-serif',
      fontSize: '0.9375rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    h4: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '0.8125rem',
      fontWeight: 600,
      color: '#666666',
    },
    body1: {
      fontFamily: '"IBM Plex Sans", sans-serif',
      fontSize: '0.9375rem',
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: '"IBM Plex Sans", sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.7,
    },
    caption: {
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '0.6875rem',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
  },

  shape: {
    borderRadius: 0,
  },

  components: {
      MuiCssBaseline: {
          styleOverrides: `
                @font-face {
                  font-family: 'IBM Plex Sans';
                  src: url('/fonts/IBM_Plex_Sans/IBMPlexSans-VariableFont_wdth,wght.ttf') format('truetype');
                  font-weight: 100 700;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Sans';
                  src: url('/fonts/IBM_Plex_Sans/IBMPlexSans-Italic-VariableFont_wdth,wght.ttf') format('truetype');
                  font-weight: 100 700;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-Regular.ttf') format('truetype');
                  font-weight: 400;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-Italic.ttf') format('truetype');
                  font-weight: 400;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-SemiBold.ttf') format('truetype');
                  font-weight: 600;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-SemiBoldItalic.ttf') format('truetype');
                  font-weight: 600;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Mono';
                  src: url('/fonts/IBM_Plex_Mono/IBMPlexMono-Regular.ttf') format('truetype');
                  font-weight: 400;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Mono';
                  src: url('/fonts/IBM_Plex_Mono/IBMPlexMono-SemiBold.ttf') format('truetype');
                  font-weight: 600;
                  font-style: normal;
                }
                body {
                  background-color: #fafafa;
                  color: #0a0a0a;
                }
                * {
                  box-sizing: border-box;
                }
  `,
      },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          textTransform: 'uppercase',
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.6875rem',
          letterSpacing: '0.08em',
          fontWeight: 600,
        },
      },
    },

    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          '&.Mui-selected': {
            backgroundColor: '#0a0a0a',
            color: '#fafafa',
            '&:hover': {
              backgroundColor: '#222222',
            },
          },
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
          borderRight: '2px solid #0a0a0a',
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#cccccc',
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.625rem',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          height: 20,
        },
      },
    },
  },
});

export default lightTheme;
